import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// Actions.
import * as AuthActions from 'actions/AuthActions';

@withRouter
@connect(
  state => ({
    auth: state.auth,
  }),
  dispatch => ({
    authActions: bindActionCreators(AuthActions, dispatch),
  })
)
export default class UserLoginDirectPage extends Component {

  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    props.authActions.loginDirect();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.auth.isLoaded !== nextProps.auth.isLoaded && nextProps.auth.isLoaded === true) {
      const { location } = nextProps;
      let destination = '/dashboard';
      const query = queryString.parse(location.search);
      if (query.destination) {
        destination = query.destination;
        delete query.destination;
      }
      delete query.token;
      delete query.session_id;
      if (/http|https/.test(destination) === true) {
        window.location = destination;
      }
      else {
        this.context.router.history.push({ pathname: destination, search: queryString.stringify(query) });
      }
    }
  }

  render() {
    return null;
  }

}
